export const createActivateRequest = (token) => {
  return {
    url: "/appsumo/activate",
    method: "POST",
    data: { token },
  };
};
